export const wpBlockCdmTableblockTableheader =
    'wp-block-cdm-tableblock-tableheader';
export const wpBlockCdmTableblockTableblock =
    'wp-block-cdm-tableblock-tableblock';
export const wpBlockGetwidTable = 'wp-block-getwid-table';
export const cdmTable = 'cdm-table';

export const testAttributes = {
    TABLE_CONTAINER: 'table-container',
};
